import React from 'react';
import ContactForm from '../../components/contacts/ContactForm';

const ContactEditPage: React.FC = () => {
  return (
    <div className="mx-auto max-w-5xl px-4 py-3">
      <ContactForm mode="edit" />
    </div>
  );
};

export default ContactEditPage;